

module.exports = __webpack_require__.stylable.create(
    "button2463893265",
    {"classes":{"root":"button2463893265__root","hollow":"button2463893265__hollow","full":"button2463893265__full","fullWidth":"button2463893265__fullWidth"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "button2463893265",
    null
);
